import { render, staticRenderFns } from "./editPracticalMarkForm.vue?vue&type=template&id=8053aa1c&"
import script from "./editPracticalMarkForm.vue?vue&type=script&lang=js&"
export * from "./editPracticalMarkForm.vue?vue&type=script&lang=js&"
import style0 from "./editPracticalMarkForm.vue?vue&type=style&index=0&id=8053aa1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports